import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle, Loader2 } from "lucide-react";

export default function CheckoutSuccess() {
  const navigate = useNavigate();
  const [activated, setActivated] = useState(false);
  const [pollCount, setPollCount] = useState(0);

  useEffect(() => {
    // Clear any stored checkout plan
    sessionStorage.removeItem("checkout_plan");

    // Poll user-me to detect subscription activation
    if (pollCount >= 10 || activated) return;

    const timer = setTimeout(async () => {
      try {
        const profile = await api.getCurrentUser();
        if (profile.subscription_status === "active" && profile.subscription_tier !== "free") {
          setActivated(true);
        } else {
          setPollCount((c) => c + 1);
        }
      } catch {
        setPollCount((c) => c + 1);
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [pollCount, activated]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-green-50 to-blue-50 dark:from-gray-900 dark:to-gray-800">
      <div className="text-center max-w-md mx-auto p-8">
        <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-6" />
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          Payment Successful!
        </h1>
        {activated ? (
          <>
            <p className="text-gray-600 dark:text-gray-400 mb-8">
              Your subscription is now active. You have full access to all
              premium features. Welcome aboard!
            </p>
            <Button onClick={() => navigate("/dashboard")} size="lg">
              Go to Dashboard
            </Button>
          </>
        ) : (
          <>
            <p className="text-gray-600 dark:text-gray-400 mb-8">
              Thank you for subscribing! We're activating your account...
            </p>
            <div className="flex items-center justify-center gap-2 text-gray-500 mb-8">
              <Loader2 className="w-5 h-5 animate-spin" />
              <span>Activating your subscription...</span>
            </div>
            {pollCount >= 10 && (
              <div className="space-y-3">
                <p className="text-sm text-gray-500">
                  This is taking longer than expected. Your subscription may take a moment to process.
                </p>
                <Button onClick={() => navigate("/dashboard")} variant="outline">
                  Go to Dashboard
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
